import { commonFilter } from './filter';

export default {
  pageName: 'channel',
  pageId: '20005',
  pagePath: '/opinion/Stats/Channel',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
